<template>
    <nav class="tab-wrap break-after">
        <ul class="tabs break-after" id="tabs" ref="tabs">
            <li v-on:click="updateTab(dat)" v-bind:key="index" v-for="(dat, index) in data" class="tab" ref="tab" v-bind:class="{'active': dat.slug===value.slug}">{{dat.name}}</li>
            <li class="presentation-slider" role="presentation" ref="presentation"></li>
        </ul>
    </nav>
</template>
<script>
    export default {
        name: 'Tabs',
        components: {},
        props: {
            data: {
                type: Array
            },
            value: {
                type: Object
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        mounted(){
            if(!this.value){
                this.value = this.data[0];
                this.updateTab(this.value);
            }
            this.initTab();


        },
        methods: {
            initTab: function(){
                var widestTab;
                var amount = 0;
                var tabs = this.$refs.tab;
                var slider = this.$refs.presentation;
                tabs.forEach(function(tab) {
                    if (widestTab) {
                        if (tab.offsetWidth > widestTab.offsetWidth) {
                            widestTab = tab;
                        }
                    } else {
                        widestTab = tab;
                    }
                    amount++;
                });
                Array.prototype.forEach.call(tabs, function(tab) {
                    tab.style.width = widestTab.offsetWidth + 1 + "px";
                });
                slider.style.width = widestTab.offsetWidth + "px";
                if (amount == 1){
                    document.getElementById('tabs').classList.add("one-tab");
                } else if (amount == 2){
                    document.getElementById('tabs').classList.add("two-tabs");
                } else if (amount == 3){
                    document.getElementById('tabs').classList.add("three-tabs");
                } else if (amount == 4){
                    document.getElementById('tabs').classList.add("four-tabs");
                } else if (amount == 5){
                    document.getElementById('tabs').classList.add("five-tabs");
                } else if (amount == 6){
                    document.getElementById('tabs').classList.add("six-tabs");
                } else {
                    document.getElementById('tabs').classList.add("unknown-tabs");
                }

            },
            updateTab(tab) {
                this.$emit('input', tab)
            }
        }
    }
</script>
<style src="./Tabs.scss" scoped lang="scss"></style>

